var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fe3155",
    points: "2,0 2,16 4,16 8,12 12,16 14,16 14,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFill);
export default __webpack_public_path__ + "static/media/bookmarkFill.19551a8fe0da9c59fa3812b880ecff3c.svg";
export { ForwardRef as ReactComponent };